import styled from 'styled-components'

type Props = {
  isActive?: boolean
}

export default styled.span<Props>`
  ${(props) => props.isActive && 'font-weight: 600;'}
`
